import React, { useEffect, useState, useContext } from "react";
import Select from "./select";
//import Select from '../common/customselect'
import Input from "./input";
import dlv from "dlv";
import BranchContext from "./../context/branch";
import Joi from "joi-browser";
import ModalSearchprofile from "../common/searchcustomer";
import ModalSearchprofilepay from "../common/searchcustomerpay";
import ModalSearchdriven from "../common/searchdrivenname";
import Modalcovid from "../common/modalcovid";
//import { getCustomer } from "./../../services/wms/grabconcept";
import {
  getCustomerType,
  getGroupTruck,
  getDriven,
  getCustomerIDWeb,
} from "./../../services/wms";
import ModalSelect from "./../common/modalselect";
import ModalSearch from "./../common/modalSearch";
import { identity } from "lodash";
import { chkcovicid } from "../../services/wms/grabconcept";
import { toast } from "react-toastify";
//import SelectCus from './selectcustomer';

const RegisterForm = ({
  handleChangeCustype,
  head,
  typename,
  name,
  drivenno,
  drivenname,
  id,
  handleChangeCustomer,
  handleChangeCustomerpay,
  onsourcedoChange,
  onChange,
  onDrivenNameChange,
  onDrivenTelChange,
  allEditData,
  registerError,
  handleSearch,
  handleTruckGroupChange,
  handelAxTruckIdChange,
  productId,onLoad
}) => {
  const { currentBranch } = useContext(BranchContext);
  const [messageErros, setmessageErros] = useState({
    askAlert: { enable: false, message: "" },
  });
  const ojb = allEditData[0];
  let editCustID = dlv(ojb, "supplier_id", 0);
  let editruckID = dlv(ojb, "AXTruckCode", 0);
  let editCustTypeId = dlv(ojb, "customerType_id", "00");
  let editDirivenId = dlv(ojb, "driven_no", "");
  let editDirivenName = dlv(ojb, "driven_name", "");
  let editDirivenTel = dlv(ojb, "driver_tel", "");
  let edittruck = dlv(ojb, "TruckOwner", 0);
  let editcustname = dlv(ojb, "customername", "");
  if (editCustID == null) {
    editCustID = 0;
  }
  if (editDirivenId == null) {
    editDirivenId = "";
  }
  //console.log(ojb);

  const [custypeId, setcustypeId] = useState(editCustTypeId);
  const [lname, setlname] = useState();
  const [custId, setcustId] = useState(editCustID);
  const [custIdpay, setcustIdpay] = useState(editCustID);
  const [truckid, settruckid] = useState(edittruck);
  const [trucklistid, settrucklistid] = useState(editruckID);

  const [custName, setcusName] = useState(editcustname);
  const [custNamepay, setcusNamepay] = useState("");
  const [listcovic, setlistcovic] = useState({
    identityId: "",
    cusid: "",
    fname: "",
    lname: "",
  });
  const [texId, setidentityId] = useState(editDirivenId);
  const [drivenName, setdrivenName] = useState(editDirivenName);
  const [drivenTel, setdrivenTel] = useState(editDirivenTel);
  const [sourcedo, setsourcedo] = useState(editDirivenTel);
  const [customerType, setcustomerType] = useState([]);

  const [grouptruck, setgrouptruck] = useState([]);

  const [trucklist, settrucklist] = useState([]);
  const [openModalcovic, setOpenModalcovic] = useState(false);

  const [customer, setcustomer] = useState([]);
  const [customerpay, setcustomerpay] = useState([]);
  const [vForm, setvForm] = useState(false);
  const [openModalSearch, setOpenModalSearch] = useState(false);
  const [openModalSearchpay, setOpenModalSearchpay] = useState(false);
  const [openModalDriven, setOpenModalDriven] = useState(false);
  const [stateData, setstateData] = useState({
    data: { identityId: "" },
    errors: { enable: false, message: "" },
  });
  let schema1 = {
    identityId: Joi.string().min(0).max(99999999).required().label("ใบขับขี่"),
  };

  const doSubmit = async () => {
    try {
      const doc = {
        identityid: texId,
        fname: Namecovic[0],
        lname: lname,
        branch_id: currentBranch && currentBranch._id,
      };
      //console.log("Test",doc)
      const { data: result } = await chkcovicid(doc);
      //console.log("result",result)
      if (result.status === "success") {
        //toast.success("บันทึกเสร็จเรียบร้อย");
        setOpenModalcovic(false);
        //  const urlGoBack = "/registerlist/";
        //  setTimeout(props.history.replace(urlGoBack), 1000);
      } else {
        setOpenModalcovic(true);
        toast.error(result.message);
      }
    } catch (err) {
      toast.error("Error Try Catch Covic-19");
    }
  };

  useEffect(() => {
    if (!currentBranch) return;
    if (!onLoad) return
    const loadData = async () => {
      const { data: result } = await getCustomerType(
        currentBranch && currentBranch._id
      );

      if (result.status === "success") {
        setcustomerType(result.data.list);
      }
    };
    loadData();
  }, [currentBranch,onLoad]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!onLoad) return
    const loadData = async () => {
      const { data: result } = await getDriven(currentBranch._id, truckid);

      if (result) {
        settrucklist(result);
      }
    };
    loadData();
  }, [currentBranch, truckid,onLoad]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!onLoad) return
    const loadData = async () => {
      const { data: result } = await getGroupTruck(
        currentBranch && currentBranch._id
      );

      if (result.status === "success") {
        setgrouptruck(result.data.list);
      }
    };
    loadData();
  }, [currentBranch,onLoad]);

  useEffect(() => {
    if (!currentBranch) return;
    if (!onLoad) return
    const loadData = async () => {
      const { data: result } = await getCustomerIDWeb(
        currentBranch && currentBranch._id
      );

      if (result) {
        setcustomer(result);
      }
    };
    loadData();
  }, [currentBranch,onLoad]);

  useEffect(() => {
    if (!onLoad) return
    if (!currentBranch) return;
    if (customer.length === 0) return;

    const loadData = () => {
      if (editCustID === 0 && customer.length === 1) {
        setcusName(customer[0].name);
        handleChangeCustomer(customer[0]._id);
      }
    };
    loadData();
  }, [currentBranch, customer, editCustID, productId,onLoad]);
  
  useEffect(() => {
    if (vForm) return;
    if (!currentBranch) return;
    const onload = () => {
      if (registerError) {
        const data = { ...stateData.data };
        setstateData({
          data,
          errors: { enable: false, message: registerError.identityId },
        });
        setvForm(true);
      } else {
        // setvForm(true);
      }
    };
    onload();
  });

  const validateProperty = ({ name, value }) => {
    try {
      const obj = { [name]: value };
      const schema = { [name]: schema1[name] };
      const options = { abortEarly: true };
      const { error } = Joi.validate(obj, schema, options);
      return error ? error.details[0].message : null;
    } catch (err) {


      return err.message;
    }
  };

  const handleChangeCustypeId = (event) => {
    setcustypeId(event.currentTarget.value);
    handleChangeCustype(event.currentTarget.value);
  };

  const handleChangeTrckId = (event) => {
    settruckid(event.currentTarget.value);

    handleTruckGroupChange(event.currentTarget.value);
  };

  const handleChangeTrucklistId = (event) => {
    settrucklistid(event.currentTarget.value);
    handelAxTruckIdChange(event.currentTarget.value);
    // console.log(event.currentTarget)
  };
  const handleChangCusId = (event) => {
    setcusName(event.currentTarget.value);
  };
  const handleChangCusIdpay = (event) => {
    if (!custNamepay) return;
    setcusNamepay(event.currentTarget.value);
  };
  const handleSearchCustomer = () => {
    setOpenModalSearch(true);
  };
  const handleSearchCustomerpay = () => {
    setOpenModalSearchpay(true);
  };
  const oncusnameKeyPress = (event) => {
    if (!custName) {
      return;
    }
    if (event.key === "Enter") {
      if (!openModalSearch) {
        setOpenModalSearch(true);
      }
    }
  };
  const oncusnameKeyPresspay = (event) => {
    if (!custNamepay) {
      return;
    }
    if (event.key === "Enter") {
      if (!openModalSearchpay) {
        setOpenModalSearchpay(true);
      }
    }
  };
  const onDrivenKeyPress = (event) => {
    if (!drivenName) {
      return;
    }
    if (event.key === "Enter") {
      if (!openModalDriven) {
        setOpenModalDriven(true);
      }
    }
  };
  const handleTextchange = ({ currentTarget: input }) => {
    const data = { ...stateData.data };
    const errors = { ...stateData.errors };
    if (input.name in data) {
      const errorMessage = validateProperty(input);
      if (errorMessage) errors[input.name] = errorMessage;
      else delete errors[input.name];
      data[input.name] = input.value;
      setstateData({ data, errors: { enable: false, message: errorMessage } });
      if (errorMessage && !input.value === "") return;

      setidentityId(input.value);

      onChange(input.value);
    }
  };
  const Namecovic = drivenName.split(" ");
  useEffect(() => {
    if (texId.length == "13") {
      if (Namecovic.length == "2") {
        setlname(Namecovic[1]);
      } else if (Namecovic.length == "3") {
        setlname(Namecovic[2]);
      } else if (Namecovic.length == "4") {
        setlname(Namecovic[3]);
      } else if (Namecovic.length == "5") {
        setlname(Namecovic[4]);
      }
    }
  }, [texId, drivenName]);

  const handleSearchClick = () => {
    setOpenModalSearch(true);
  };
  const handleCovicClick = () => {
    setlistcovic({
      identityId: texId,
      cusid: custId,
      fname: Namecovic[0],
      lname: lname,
    });
  };
  const handleSearchDrinvenClick = () => {
    setOpenModalDriven(true);
  };
  const handleTextdrivenNamechange = ({ currentTarget: input }) => {
    setdrivenName(input.value);
    onDrivenNameChange(input.value);
  };

  const handleConfirmSubmit = (event) => {
    setcusName(event.name);
    setOpenModalSearch(false);
    handleChangeCustomer(event._id);
    setcustId(event._id);
  };
  const handleConfirmSubmitpay = (event) => {
    if (!event) return;
    setcusNamepay(event.name);
    setOpenModalSearchpay(false);
    handleChangeCustomerpay(event._id);
    setcustIdpay(event._id);
  };
  const handleConfirmDrivenSubmit = (value) => {
    setOpenModalDriven(false);
    setidentityId(value.id);
    setdrivenName(value.name);
    setdrivenTel(value.name1);
  };
  const handleopencovic = () => {
    setlistcovic({
      identityId: texId,
      cusid: custId,
      fname: Namecovic[0],
      lname: lname,
    });
    setOpenModalcovic(true);
  };
  const handleCanclecovic = () => {
    setOpenModalcovic(false);
  };
  const handleCancleSubmit = () => {
    setOpenModalSearch(false);
  };
  const handleCancleSubmitpay = () => {
    setOpenModalSearchpay(false);
  };
  const handleCancleDrivenSubmit = () => {
    setOpenModalDriven(false);
  };
  const handleTextdrivenTelchange = ({ currentTarget: input }) => {
    setdrivenTel(input.value);
    onDrivenTelChange(input.value);
  };
  const handleTextsourcedo = ({ currentTarget: input }) => {
    setsourcedo(input.value);
    onsourcedoChange(input.value);
  };

  if (!currentBranch) {
    return <p></p>;
  }
  return (
    <div className="container-fluid">
      <Modalcovid
        isOpen={openModalcovic}
        header={"แบบประเมิณ Covid-19"}
        list={listcovic}
        onCancel={handleCanclecovic}
        onSelect={handleConfirmSubmit}
      />
      <ModalSearchprofile
        isOpen={openModalSearch}
        header={"ข้อมูลผู้ขาย/ลูกค้า"}
        search={custName}
        list={customer}
        onCancel={handleCancleSubmit}
        onSelect={handleConfirmSubmit}
      />
      <ModalSearchprofilepay
        isOpen={openModalSearchpay}
        header={"ข้อมูลผู้ขาย/ลูกค้า"}
        search={custNamepay}
        list={customerpay}
        onCancel={handleCancleSubmitpay}
        onSelect={handleConfirmSubmitpay}
      />
      <ModalSearchdriven
        isOpen={openModalDriven}
        header="คนขับ"
        onCancel={handleCancleDrivenSubmit}
        onSelect={handleConfirmDrivenSubmit}
        placeholder="ชื่อ-สกุล/เลขบัตร"
        search={drivenName}
      />

      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <span className="bg-info text-white ">
              <span className="info-box-icon  ">
                <i className="fa fa-users ml-2 my-2" />
              </span>
              <span> {head} </span>
            </span>
            <div className="card-body ">
              <div className="row">
                <div className="col-sm-6">
                  <div className="form-group">
                    {/* <Combobox/> */}

                    <Select
                      label={typename}
                      data={customerType}
                      value={custypeId}
                      textProperty="name"
                      valueProperty="_id"
                      onChange={handleChangeCustypeId}
                    />
                  </div>
                </div>

                <div className="col-sm-6">
                  <Input
                    name="customer"
                    value={custName}
                    label={name}
                    onChange={handleChangCusId}
                    onClick={handleSearchCustomer}
                    onKeyPress={oncusnameKeyPress}
                    className="btn btn-primary"
                    // error={stateData.errors.message}
                    search="ค้นหา"
                  />
                </div>
              </div>
              {currentBranch &&
                currentBranch._id == "503" &&
                productId == "164" && (
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <Input
                          name="sourcedo"
                          value={sourcedo}
                          label="ใบนำส่ง(ต้นทาง)"
                          onChange={handleTextsourcedo}
                        />
                      </div>
                    </div>

                    <div className="col-sm-6">
                      <Input
                        name="customerpay"
                        value={custNamepay}
                        label={"ชื่อลูกค้า(ทำจ่าย)"}
                        placeholder="กดค้นหา ลูกค้า(ทำจ่าย)"
                        onChange={handleChangCusIdpay}
                        onClick={handleSearchCustomerpay}
                        onKeyPress={oncusnameKeyPresspay}
                        className="btn btn-primary"
                        // error={stateData.errors.message}
                        search="ค้นหา"
                      />
                    </div>
                  </div>
                )}
              <div className="row">
                <div className="col-sm-6 my-1">
                  <Input
                    name="drivername"
                    value={drivenName}
                    label={drivenname}
                    search="ค้นหา"
                    className="btn btn-primary"
                    onClick={handleSearchDrinvenClick}
                    onKeyPress={onDrivenKeyPress}
                    onChange={handleTextdrivenNamechange}
                  />
                </div>
                <div className="col-sm-6 my-1">
                  <Input
                    name="identityId"
                    value={texId}
                    label={drivenno}
                    // search="Covid-19"
                    className="btn btn-danger"
                    onClick={handleopencovic}
                    onChange={handleTextchange}
                    error={stateData.errors.message}
                  />
                </div>
                <div className="col-sm-6 my-1">
                  <Input
                    name="drivertel"
                    value={drivenTel}
                    label="เบอร์โทร"
                    onChange={handleTextdrivenTelchange}
                  />
                  {/* <div className="col-sm-6 my-1">
                 <button     
                 className="btn btn-danger" size="lg">
                 ประเมิณ Covic-19
                </button>
               </div> */}
                </div>

                {grouptruck && grouptruck.length > 0 && (
                  <div className="col-sm-6">
                    <div className="form-group">
                      {/* <Combobox/> */}

                      <Select
                        label={"ประเภทการจัดส่ง"}
                        data={grouptruck}
                        value={truckid}
                        textProperty="name"
                        valueProperty="_id"
                        onChange={handleChangeTrckId}
                      />
                    </div>
                  </div>
                )}

                {trucklist && trucklist.length > 0 && (
                  <div className="col-sm-6">
                    <div className="form-group">
                      {/* <Combobox/> */}

                      <Select
                        label={"ข้อมูลการจัดส่ง"}
                        data={trucklist}
                        value={trucklistid}
                        textProperty="name"
                        valueProperty="id"
                        onChange={handleChangeTrucklistId}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="row"></div>
            </div>
          </div>
        </div>

        {/* <Select2/> */}
      </div>
    </div>
  );
};

export default RegisterForm;
